import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Form, Input } from 'semantic-ui-react';
import i18next from 'i18next';
import { editEntityField, sendInvoice } from '../../../actions';
import currencyOptions from '../../../consts/CommonCurrency.json';

import './SendInvoice.scss';

class SendInvoice extends Component {

    handleSubmit = (event) => {
        this.props.sendInvoice(this.props.entity);
        event.preventDefault();
    }

    render() {
        const invoice = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('recipient')}</label>
                    <input
                        placeholder={i18next.t('recipient')}
                        value={invoice.recipient || ''}
                        onChange={({ target }) => this.props.editEntityField('recipient', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('amount')}</label>
                    <Input
                        fluid
                        label={{ basic: true, content: currencyOptions[invoice.currency_code || 'ILS'].symbol_native }}
                        labelPosition='right'
                        type='text'
                        placeholder={i18next.t('amount')}
                        required
                        value={invoice.amount || 0}
                        onChange={({ target }) => this.props.editEntityField('amount', parseInt(target.value, 10))}
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('vat')}</label>
                    <input
                        placeholder={i18next.t('vat')}
                        value={invoice.vat || ''}
                        onChange={({ target }) => this.props.editEntityField('vat', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('email')}</label>
                    <input
                        placeholder={i18next.t('email')}
                        value={invoice.email || ''}
                        onChange={({ target }) => this.props.editEntityField('email', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('text')}</label>
                    <Form.TextArea
                        rows={5}
                        value={invoice.text || ''}
                        onChange={({ target }) => this.props.editEntityField('text', target.value)}
                    />
                </Form.Field>

                <Button primary type='submit' floated="right">
                    {i18next.t('sendInvoice')}
                </Button>
            </Form>
        );
    }
}

SendInvoice.propTypes = {
    editEntityField: PropTypes.func,
    sendInvoice: PropTypes.func,
    category: PropTypes.object,
    items: PropTypes.array,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { editEntityField, sendInvoice })(SendInvoice);
